import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var updateAdvancedIncomingAuth = mutatorAction('updateAdvancedIncomingAuth', function (incomingAuth) {
    var store = connectedAccountsStore();
    store.connectAdvancedState.incomingAuth = incomingAuth;
});
//# sourceMappingURL=updateAdvancedIncomingAuth.js.map